/**
 * Security Parameter Delta lockout — the enforced go-dark state.
 * Rendered in the §2d "critical" register (red), same console language as the
 * rest of the surface. Enforced by server-persisted lockoutUntil (refresh-proof);
 * reconnect is gated upstream in KidMode. This just renders + ticks the clock.
 */
import { useEffect, useState } from "react";

export default function Lockout({
  until,
  onExpire,
}: {
  until: number;
  onExpire: () => void;
}) {
  const [remaining, setRemaining] = useState(() => Math.max(0, until - Date.now()));

  useEffect(() => {
    const t = setInterval(() => {
      const r = Math.max(0, until - Date.now());
      setRemaining(r);
      if (r <= 0) {
        clearInterval(t);
        onExpire();
      }
    }, 250);
    return () => clearInterval(t);
  }, [until, onExpire]);

  const secs = Math.ceil(remaining / 1000);
  const mm = String(Math.floor(secs / 60)).padStart(2, "0");
  const ss = String(secs % 60).padStart(2, "0");

  return (
    <div className="kid-lockout" role="alertdialog" aria-label="System locked">
      <div className="kid-lockout__frame">
        <span className="kid-corner kid-corner--tl kid-corner--red" />
        <span className="kid-corner kid-corner--tr kid-corner--red" />
        <span className="kid-corner kid-corner--bl kid-corner--red" />
        <span className="kid-corner kid-corner--br kid-corner--red" />
        <div className="kid-lockout__label">SECURITY PARAMETER DELTA — ACTIVE</div>
        <div className="kid-lockout__title">JARVIS OFFLINE</div>
        <div className="kid-lockout__sub">Standby. Access restored on cooldown.</div>
        <div className="kid-lockout__timer">{mm}:{ss}</div>
      </div>
    </div>
  );
}
